import React, { createContext, useState } from 'react';

import PropTypes from 'prop-types';

export const Context = createContext({});

const bookingsData = {
  firstName: 'COLLIN',
  lastName: 'MORIKAWA',
  profession: 'PGA Tour Professional',
  clientName: 'Tom',
  MyBookings: [
    {
      days: 3,
      when: 'In 3 days',
      service: 'One-on-One Private Lessons',
      day: 'Monday, July 14, 2020',
      time: '9:00am - 10:00am - 1hr',
      location: '123 Main Street, 18',
      total: '$250.00 - PAID',
      guests: 4,
    },
    {
      days: 5,
      when: 'In 5 days',
      service: 'Group Lessons',
      day: 'Tuesay, July 21, 2020',
      time: '8:00am - 10:00am - 2hr',
      location: '123 Main Street, 18',
      total: '$400.00 - PAID',
      guests: 5,
    },
    {
      days: -2,
      when: '2 days ago',
      service: 'One-on-One Private Lessons',
      day: 'Monday, Jun 14, 2020',
      time: '9:00am - 10:00am - 1hr',
      location: '123 Water Street',
      total: '$250.00 - PAID',
      guests: 4,
    },
  ],
};

export const Provider = ({ children }) => {
  const [bookings, setBookings] = useState('0');

  const contextData = {
    bookingsData,
    setBookings,
    bookings,
  };
  return (
    <Context.Provider
      value={{
        contextData,
        bookings,
        setBookings,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const { Consumer } = Context;

Provider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
